import React from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import {
  Box,
  Button,
  Divider,
  FormControl,
  Paper,
  TextField,
  Typography,
  InputAdornment
} from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { DebounceInput } from 'react-debounce-input';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from 'react-fetching-library';

import { AlertDialogContainer } from '../others/AlertDialogContainer';
import { resetPasswordCompleteAction } from '../../services/request';
import { useFullScreen } from '../../services/hooks';

export const NewPasswordPage = () => {
  const mediaWidth = useFullScreen() ? '300px' : '450px';
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [alertTitle, setAlertTitle] = React.useState('');
  const [alertMessage, setAlertMessage] = React.useState('');

  const navigate = useNavigate();

  const validationSchema = Yup.object({
    password1: Yup.string()
      .required('To pole nie może być puste')
      .max(128, 'Hasło może mięc najwyżej 128 znaków'),
    password2: Yup.string()
      .required('To pole nie może być puste')
      .min(8, 'Hasło musi mieć co najmniej 8 znaków')
      .max(128, 'Hasło może mięc najwyżej 128 znaków')
      .oneOf([Yup.ref('password1')], 'Wpisz poprawne hasło')
  });

  const initialValues = {
    password1: '',
    password2: ''
  };

  const { mutate } = useMutation(resetPasswordCompleteAction);
  const { uidb64, token } = useParams();

  const [success, setSuccess] = React.useState(false);

  const handleSubmit = async values => {
    const { error, payload } = await mutate({ ...values, uidb64, token });
    if (!error) {
      setSuccess(true);

      setAlertTitle('Sukces!');
      setSeverity('success');
      setAlertMessage('Twoje hasło zostało pomyślnie zmienione. Za chwilę zostaniesz przekierowany na stronę logowania');
      setShowAlert(true);

      setTimeout(() => {
        navigate('/login');
      }, 2000);

    } else {
      setSeverity('error');
      setAlertTitle('Błąd');
      setAlertMessage(payload?.message);
      setShowAlert(true);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      component={Paper}
      elevation={4}
      padding={8}
    >
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={alertTitle}
          message={alertMessage}
          setShowAlert={setShowAlert}
        />
      )}
      <Box>
        <Typography color="primary" variant="h5" align="center">
        Zmień hasło
        </Typography>
      </Box>
      <Divider style={{ width: mediaWidth, marginTop: 20 }} />
      <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <FormControl
          style={{
            marginTop: 50,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
        </FormControl>
        <FormControl
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography color="primary" variant="h6">
            Hasło
          </Typography>
          <DebounceInput
            variant="outlined"
            type="password"
            name="password1"
            id="password1"
            value={formik.values.password1}
            onChange={formik.handleChange}
            error={formik.touched.password1 && Boolean(formik.errors.password1)}
            helperText={formik.touched.password1 && formik.errors.password1}
            debounceTimeout={100}
            element={TextField}
            style={{ marginRight: 10, marginBottom: 10 }}
            disabled={success}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOpenIcon />
                </InputAdornment>
              )
            }}
          />
        </FormControl>
        <FormControl
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography color="primary" variant="h6">
            Powtórz hasło
          </Typography>
          <DebounceInput
            variant="outlined"
            type="password"
            name="password2"
            id="password2"
            value={formik.values.password2}
            onChange={formik.handleChange}
            error={formik.touched.password2 && Boolean(formik.errors.password2)}
            helperText={formik.touched.password2 && formik.errors.password2}
            debounceTimeout={100}
            element={TextField}
            style={{ marginRight: 10, marginBottom: 10 }}
            disabled={success}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOpenIcon />
                </InputAdornment>
              )
            }}
          />
        </FormControl>
        <Divider style={{ width: mediaWidth, marginTop: 20, marginBottom: 20 }} />
        <Button
          color="primary"
          variant="contained"
          type="submit"
          style={{ marginBottom: 20 }}
          disabled={success}
        >
      Zmień
        </Button>
      </form>
      <Box display="flex" flexDirection="row" justifyContent="center">
      </Box>
    </Box>
  );
};
